import React from 'react';
import {Form, Textarea, List} from 'components';
import {useNamedSelector} from 'helpers';

export function Career() {
  return (
    <Form {...useNamedSelector('clarity.form', { name: 'career' })}>
      <List tiny-gutter>
        <List.Title>What is missing from your professional life?</List.Title>
        <Textarea single name="1" />
        <List.Title>What skills/strengths are you not using in your work life?</List.Title>
        <Textarea single name="2" />
        <List.Title>If you no longer had to work, what would you choose to do?</List.Title>
        <Textarea single name="3" />
        <List.Title>How do your beliefs about yourself stop you from achieving greater success at work or in your business?</List.Title>
        <Textarea single name="4" />
        <List.Title>What are your fears as they relate to work and/or money?</List.Title>
        <Textarea single name="5" />
        <List.Title>If you could design your ideal job, what would it look like?</List.Title>
        <Textarea single name="6" />
        <List.Title>When does your work not feel like work?</List.Title>
        <Textarea single name="7" />
        <List.Title>What did you dream about doing when you were a child?</List.Title>
        <Textarea single name="8" />
        <List.Title>What can you do/change to be more passionate about your work?</List.Title>
        <Textarea single name="9" />
      </List>
    </Form>
  );
}
